import React from 'react';
import { Form, Select } from 'antd';

import {FontSizeList} from './FontSizeList';

const FontSizeSelector = (props) => {
    const { Option } = Select;
    
    return (
        <Form.Item
            name="font_size"
            label="Font Size"
            rules={[
                {
                    required: true,
                    message: 'Font Size is required',
                }
            ]}
        >
            <Select
                style={{ width: 200 }}
                placeholder="Select a font size"
                className="light-darkable custom_font_select"
            >
                {FontSizeList.map((size, index) => (
                    <Option key={`font-size-${index}`} value={size}>
                        {size}
                    </Option>
                ))}
            </Select>
        </Form.Item>
    );
}

export default FontSizeSelector;